import type { ReactNode } from 'react';
import styled from 'styled-components';
import { ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import type { MenuViewModel } from 'autogen/swagger/all';
import Menu from 'components/generic/menu';
import { customScrollbar } from 'modules/helpers/mixins';

const StyledMenu = styled(Menu)`
    && {
        display: grid;
        grid-auto-rows: min-content;
        position: relative;
        overflow: auto;
        overscroll-behavior: contain;
        background-color: ${ColorNeutralWhite};
        height: 100%;
        flex: 1;

        ul:last-of-type {
            &:after {
                display: none;
            }
        }

        ${customScrollbar};
    }
`;

const GreyMenu = styled(StyledMenu)`
    && {
        background-color: ${({ theme }) => theme.ColorBackgroundSecondary};
    }
`;

const WhiteMenu = styled(StyledMenu)`
    && {
        background-color: ${ColorNeutralWhite};
    }
`;

/**
 * MenuStyleRenderer handles the styling variations of Menu that can come from MenuViewModel
 */
export default function MenuStyleRenderer({
    styling,
    children
}: {
    styling: MenuViewModel['styling'];
    children: ReactNode;
}) {
    switch (styling) {
        case 'White':
            return <WhiteMenu shouldFocus>{children}</WhiteMenu>;
        default:
            return <GreyMenu shouldFocus>{children}</GreyMenu>;
    }
}
